import { render, staticRenderFns } from "./element-trigger-icon.vue?vue&type=template&id=206b980e&scoped=true"
import script from "./element-trigger-icon.vue?vue&type=script&lang=js"
export * from "./element-trigger-icon.vue?vue&type=script&lang=js"
import style0 from "./element-trigger-icon.vue?vue&type=style&index=0&id=206b980e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b980e",
  null
  
)

export default component.exports